export default "__VITE_ASSET__Do4RmNAD__"